var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"variant":"primary","depressed":"","tile":""},on:{"click":function($event){return _vm.$emit('click')}}},[_c('b-icon',{attrs:{"icon":"plus-circle-fill","aria-hidden":"true"}}),_vm._v(" ADD NEW ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }